"use client";

import { useCallback, useEffect, useState } from "react";
import { Nav, Tab } from "react-bootstrap";
import {
  LogoutOutlined,
  MoreOutlined,
  ReloadOutlined,
  SettingOutlined,
  UserOutlined,
} from "@ant-design/icons";
import { Button, DatePicker, Dropdown, Menu, message } from "antd";
import PropTypes from "prop-types";
import AddPatientPopup from "../../appointmentBooking/AddPatientPopUp";
import { InputGroup, FormControl } from "react-bootstrap";
import { SearchOutlined, LeftOutlined, RightOutlined } from "@ant-design/icons";
import dayjs from "dayjs";
import { male, female } from "../../imagepath";
import { Grid } from "antd";
import { useAuth } from "../../../services/authentication_API/authService";
import {
  deleteAppointment,
  getAppointments,
  getPatientList,
  updateAppointment,
} from "../../../services/receptionist/book appointment/bookappointment";
import { Link } from "react-router-dom";
const { useBreakpoint } = Grid;
import { CloseOutlined, PlusOutlined } from "@ant-design/icons";
import { Tag, Input, Space, Typography, Card, Divider } from "antd";
import { useMessageApi } from "../../../services/message api/MessageProvider";
import Loader from "../../Loader";
import { getLabAppointments } from "../../../services/lab/lab_appointment";

export default function Lab_PatientsQueue({
  onPatientSelect,
  appoimentBooked,
  setAppoimentBooked,
}) {
  const screens = useBreakpoint();
  const [activeTab, setActiveTab] = useState("Pending");
  const [selectedDate, setSelectedDate] = useState(dayjs());
  const [showPopup, setShowPopup] = useState(false);
  const [patients, setPatients] = useState([]);
  const [selectedIndex, setSelectedIndex] = useState("Lab_Report");
  const [filteredPatients, setFilteredPatients] = useState([]);
  const [loading, setLoading] = useState(true);
  const [statusUpdated, setStatusUpdated] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [count, setCount] = useState({});
  const [selectedPatient, setSelectedPatient] = useState(null);
  const messageApi = useMessageApi();

  const { logout, user, userData } = useAuth();
  const onpatientSelect = (patient) => {
    setSelectedPatient(patient);
    onPatientSelect(patient);
  };

  message.config({
    top: 100, // distance from top
    duration: 3,
    placement: "topRight", // <-- key part for right side
  });

  const fetchAppointmens = async () => {
    try {
      setLoading(true);
      const result = await getLabAppointments(
        0,
        selectedDate.format("YYYY-MM-DD")
      );
      if (result.success) {
        console.log("Formatted Data:", result);
        setPatients(result?.data);
        const filtered = result?.data?.filter(
          (item) => item?.status === selectedIndex
        );
        console.log("Filtered Patients:", filtered);
        const statusCounts = result?.data?.reduce((acc, item) => {
          const status = item?.status;
          if (status) {
            acc[status] = (acc[status] || 0) + 1;
          }
          return acc;
        }, {});
        setCount(statusCounts);
        setFilteredPatients(filtered);
        // setSelectedIndex("Consult");
        setStatusUpdated(false);
      } else {
        console.error("Error:", result.error || "Failed to fetch Appointments");
      }
    } catch (err) {
      console.error("Exception:", err.message);
    } finally {
      setLoading(false);
    }
  };

  const updateAppointments = async (patient, status) => {
    const patient1 = { ...patient, status: status, _method: "put" };
    try {
      const result = await updateAppointment(patient1);
      if (result.success) {
        messageApi.open({
          type: "success",
          content: "Status updated successfully",
        });
      } else {
        console.error("Status Updation failed:", result.error);
        // Display error messages...
      }
    } catch (err) {
      console.error("Failed to update doctor:", err);
      messageApi.open({
        type: "error",
        content: "Failed to update doctor. Please try again.",
      });
    }
  };
const handleSearch = async (query) => {
    const trimmedQuery = (query || "").trim();
    setLoading(true);
    if (trimmedQuery.length >= 2) {
      try {
        const result = await getPatientList(trimmedQuery);
        if (result.success) {
          setFilteredPatients(result?.data || []);
        }else{
          setFilteredPatients([]);
        }
      } catch (err) {
        console.error("Exception:", err.message);
      }finally{
        setLoading(false);
      }
    } else {
      // If search is cleared or < 3 chars, reset to the current tab's list
      setOnSelectedIndex(selectedIndex); 
    }
  };

    const deleteAppoint = async (id) => {
      try {
        setLoading(true);
        const result = await deleteAppointment(id);
        if (result.success) {
          messageApi.open({
            type: "success",
            content: "Appointment deleted successfully!",
          });
          // Refresh the appointment list
          setLoading(false);
          fetchAppointmens();
        } else {
          messageApi.error(result.error || "Failed to delete appointment");
          setLoading(false);
        }
      } catch (err) {
        messageApi.error(err.message || "Error deleting appointment");
        setLoading(false);
      }
    };

  useEffect(() => {
    fetchAppointmens();
  }, [statusUpdated, selectedDate]);

  useEffect(() => {
    setOnSelectedIndex(selectedIndex);
  }, [selectedIndex]);

useEffect(() => {
  if (searchQuery.length >= 2) {
      setLoading(true);
    }
    else{
      setLoading(false);
      setOnSelectedIndex(selectedIndex);
      return;
    }
    // Set a timer to run the search after 500ms
    const delayDebounceFn = setTimeout(() => {
      if (searchQuery.length >= 2) {
        handleSearch(searchQuery);
      } 
    }, 500); // 500ms delay

    // Cleanup: This cancels the timer if the user types again before 500ms is up
    return () => clearTimeout(delayDebounceFn);
  }, [searchQuery, selectedIndex]);

  const setOnSelectedIndex = (index) => {
    setSelectedIndex(index);
    console.log("Selected Index:", index);
    const filtered = patients.filter((item) => item?.status === index);
    setFilteredPatients(filtered);
    console.log("Filtered Patients:", filteredPatients);
  };

  const handlePrev = () => {
    setSelectedDate((prev) => prev.subtract(1, "day"));
  };

  const handleNext = () => {
    setSelectedDate((prev) => prev.add(1, "day"));
  };

  const customFormat = (value) => {
    return dayjs().isSame(value, "day")
      ? "Today"
      : value.format("D MMM");
  };

  // Responsive font sizes
  const getFontSize = (base, sm, xs) => {
    if (screens.xs) return xs;
    if (screens.sm) return sm;
    return base;
  };

  // Mock patient data

  const handleAddPatient = useCallback(() => {
    setShowPopup(true);
  }, []);

  const handleClosePopup = (patient) => {
    setShowPopup(false);
    console.log("First name from popup:", patient?.first_name);
    setSearchQuery(patient?.first_name || "");
    if(patient) onPatientSelect({ patient }), setAppoimentBooked(false);

  };
  const handleRefresh = () => {
    fetchAppointmens();
  };

  const checkDoneStatus = (createdAt) => {
    if (!createdAt) return "--";
    const created = dayjs(createdAt);
    if (!created.isValid()) return "--";
    const now = dayjs();
    // Prevent negative values if createdAt is in the future
    const diffMinutes = Math.max(now.diff(created, "minute"), 0);
    const hours = Math.floor(diffMinutes / 60);
    const minutes = diffMinutes % 60;
    // If less than 1 minute, show "Just now"
    if (diffMinutes === 0) return "Just now";
    return `${hours}h ${minutes}m`;
  };
  const isToday =
  selectedDate && selectedDate.isSame(dayjs(), "day");
  const menu = (
    <Menu>
      <Menu.Item key="1">View Profile</Menu.Item>
      <Menu.Item key="2">Remove from Queue</Menu.Item>
      <Menu.Item key="3">Mark As Seen</Menu.Item>
    </Menu>
  );
  const menu1 = (
    <Menu>
      {/* View Profile */}
      <Menu.Item key="view-profile" icon={<UserOutlined />}>
        <Link to="/lab-profile">View Profile</Link>
      </Menu.Item>

      <Menu.Item key="logout" icon={<LogoutOutlined />}>
        <Link onClick={logout} to="/login">
          Log Out
        </Link>
      </Menu.Item>
    </Menu>
  );

  return (
    <div
      className="h-100 d-flex flex-column"
      style={{
        background: "#fff",
        overflow: "hidden",
      }}
    >
      <div className="patient-queue d-flex flex-column h-100">
        {/* Search Bar */}
        <div
          className="search-bar p-2 d-flex align-items-center border-bottom"
          style={{
            gap: "8px",
            flexShrink: 0,
            background: "#fafafa",
          }}
        >
          <Input
            placeholder="Search patients..."
            prefix={<SearchOutlined style={{ color: "#999" }} />}
            allowClear={{
              clearIcon: (
                <CloseOutlined
                  onClick={(e) => {
                    e.stopPropagation();
                    setSearchQuery("");
                  }}
                />
              ),
            }}
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            onClick={(e) => e.stopPropagation()}
            onPressEnter={(e) => setSearchQuery(searchQuery)}
            style={{
              width: "70%",
              height: "123%",
              fontSize: getFontSize("14px", "13px", "12px"),
              borderRadius: "6px",
              padding: screens.xs ? "2px 8px" : "0px 10px",
              boxShadow: "0 1px 3px rgba(0,0,0,0.08)",
            }}
          />

          <DatePicker
            size={screens.xs ? "small" : "middle"}
            value={selectedDate}
            onChange={(date) => setSelectedDate(date)}
            format={ customFormat}
            allowClear={false}
            // disabledDate={(current) =>
            //   current && current < dayjs().startOf("day")
            // }
            style={{
              width: "20%",
              fontSize: getFontSize("14px", "13px", "12px"),
              height: "123%",
            }}
          />

          <Button
            size={screens.xs ? "small" : "middle"}
            icon={<ReloadOutlined />}
            onClick={handleRefresh}
            style={{
              fontSize: getFontSize("14px", "13px", "12px"),

              height: "123%",
            }}
          />

          <Dropdown overlay={menu1} trigger={["click"]} placement="bottomRight">
            <button
              className="btn btn-light ms-auto"
              style={{
                width: getFontSize("40px", "36px", "32px"),
                height: getFontSize("40px", "36px", "32px"),
                padding: "0",
                fontSize: getFontSize("16px", "14px", "12px"),
              }}
            >
              <i className="fa fa-cog"></i>
            </button>
          </Dropdown>
          {showPopup && (
            <AddPatientPopup
              show={showPopup}
              handleClose={handleClosePopup}
              patientName={searchQuery}
            />
          )}
        </div>

        {/* Date Navigator */}
        {searchQuery.length < 2 ? (
          loading ? (
            <Loader />
          ) : (
            <>
              {/* <div
                className="date-navigator d-flex align-items-center justify-content-between p-2 border-bottom"
                style={{
                  flexShrink: 0,
                  background: "#fff",
                }}
              >
                {/* <Button
                  size={screens.xs ? "small" : "middle"}
                  icon={<LeftOutlined />}
                  onClick={handlePrev}
                  style={{ fontSize: getFontSize("14px", "13px", "12px") }}
                /> */}

              {/* <Button
                  size={screens.xs ? "small" : "middle"}
                  icon={<RightOutlined />}
                  onClick={handleNext}
                  style={{ fontSize: getFontSize("14px", "13px", "12px") }}
                /> 
              </div> */}

              {/* Tabs */}
              <div
                className="d-flex flex-column h-100"
                style={{ position: "relative" }}
              >
                <Tab.Container
                  activeKey={selectedIndex || "Consult"}
                  onSelect={(k) => setSelectedIndex(k || "Consult")}
                >
                  <Nav
                    variant="tabs"
                    className="queue-tabs border-bottom"
                    style={{
                      overflowY: "hidden", // prevent vertical scrolling
                      overflowX: "auto", // (optional) keep horizontal scroll if needed
                      flexWrap: "nowrap",
                      WebkitOverflowScrolling: "touch",
                      msOverflowStyle: "-ms-autohiding-scrollbar",
                      flexShrink: 0,
                      background: "#fff",
                      justifyContent: "space-around",
                    }}
                  >
                    <Nav.Item
                      style={{
                        minWidth: getFontSize("auto", "120px", "100px"),
                      }}
                    >
                      <Nav.Link
                        eventKey="Lab_Report"
                        onClick={() => {
                          setSelectedIndex("Lab_Report");
                        }}
                        style={{
                          fontSize: getFontSize("14px", "13px", "12px"),
                          fontWeight: "bold",

                          padding: getFontSize(
                            "12px 16px",
                            "10px 10px",
                            "8px 12px"
                          ),
                          borderBottom:
                            selectedIndex === "Lab_Report"
                              ? "3px solid #007bff"
                              : "2px solid transparent",
                          backgroundColor:
                            selectedIndex === "Lab_Report"
                              ? " #e0f8ff"
                              : "transparent",
                        }}
                      >
                        Pending ({count?.Lab_Report || 0})
                      </Nav.Link>
                    </Nav.Item>
                    <Nav.Item
                      style={{
                        minWidth: getFontSize("auto", "120px", "100px"),
                      }}
                    >
                      <Nav.Link
                        eventKey="Done"
                        onClick={() => {
                          setSelectedIndex("Done");
                        }}
                        style={{
                          color: "#a010f3ff",
                          fontWeight: "bold",

                          fontSize: getFontSize("14px", "13px", "12px"),
                          padding: getFontSize(
                            "12px 16px",
                            "10px 10px",
                            "8px 12px"
                          ),
                          borderBottom:
                            selectedIndex === "Done"
                              ? "3px solid #007bff"
                              : "2px solid transparent",
                          backgroundColor:
                            selectedIndex === "Done"
                              ? " #e0f8ff"
                              : "transparent",
                        }}
                      >
                        Done ({count?.Done || 0})
                      </Nav.Link>
                    </Nav.Item>
                  </Nav>
                  {/* ====== Scrollable Tab Content ====== */}
                  <div
                    className="flex-grow-1"
                    style={{
                      overflowY: "auto",
                      overflowX: "hidden",
                      height: "calc(100% - 90px)",
                      paddingBottom: "50px", // to avoid content being hidden behind bottom tabs
                    }}
                  >
                    <Tab.Content
                      className="flex-grow-1"
                      style={{ minHeight: 0, paddingTop: "0px" }}
                    >
                      <Tab.Pane eventKey={selectedIndex} className="h-100">
                        {/* ====== Example: Consult Section ====== */}
                        {selectedIndex === "Consult" && (
                          <div
                            className="upcoming-label p-2 bg-light border-bottom"
                            style={{ flexShrink: 0 }}
                          >
                            <small
                              style={{
                                fontSize: getFontSize("13px", "12px", "11px"),
                              }}
                            >
                              Upcoming
                            </small>
                          </div>
                        )}

                        <div
                          className="patient-list"
                          style={{
                            flex: 1,
                            overflowY: "auto",
                            overflowX: "hidden",

                            scrollbarWidth: "thin",
                            scrollbarColor: "#ccc transparent",
                          }}
                        >
                          {filteredPatients.length === 0 && (
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                height: "100%",
                                width: "100%",
                              }}
                            >
                              <small
                                style={{
                                  fontSize: getFontSize("13px", "12px", "11px"),
                                }}
                              >
                                No Appointments found.
                              </small>
                            </div>
                          )}

                          {/* ====== Patient List Rendering ====== */}
                          {filteredPatients?.map((patient, index) => (
                            <div
                              key={`${patient.id}-${index}`}
                              className="patient-item border-bottom d-flex align-items-center"
                              onClick={() => {
                                onpatientSelect(patient);
                                setAppoimentBooked(true);
                              }}
                              style={{
                                cursor: "pointer",
                                padding: "12px 8px",
                                transition: "background-color 0.2s",
                                backgroundColor:
                                  selectedPatient?.id === patient?.id
                                    ? "#f0f0f0ff"
                                    : "transparent",
                              }}
                            >
                              {/* Left: Avatar */}
                              <div
                                style={{
                                  width: "40px",
                                  height: "40px",
                                  borderRadius: "20%",
                                  padding: "2px",
                                  overflow: "hidden",
                                  flexShrink: 0,
                                  marginRight: "10px",
                                  backgroundColor: "#c5c5c5ff",
                                }}
                              >
                                <img
                                  src={
                                    patient?.patient?.gender === "Male"
                                      ? male
                                      : female
                                  }
                                  alt="Patient"
                                  style={{
                                    width: "100%",
                                    height: "100%",
                                    objectFit: "cover",
                                  }}
                                />
                              </div>

                              {/* Right: Info */}
                              <div className="d-flex justify-content-between align-items-center flex-grow-1">
                                <div
                                  className="flex-grow-1"
                                  style={{ minWidth: 0 }}
                                >
                                  <div className="d-flex justify-content-between align-items-center mb-2">
                                    <h6
                                      className="mb-0 text-truncate"
                                      style={{
                                        fontSize: getFontSize(
                                          "16px",
                                          "16px",
                                          "14px"
                                        ),
                                        fontWeight: 600,
                                        maxWidth: "70%",
                                      }}
                                    >
                                      {patient?.patient?.first_name}{" "}
                                      {patient?.patient?.last_name}
                                    </h6>
                                    <span
                                      className="text-muted"
                                      style={{
                                        fontWeight: 600,
                                        fontSize: getFontSize(
                                          "13px",
                                          "14px",
                                          "11px"
                                        ),
                                      }}
                                    >
                                      {patient?.reason_for_appointment ==
                                        "Follow Up" && (
                                        <Tag
                                          style={{
                                            marginLeft: "8px",
                                            color: "white",
                                            fontWeight: 600,
                                            background: "green",
                                          }}
                                        >
                                          Follow Up
                                        </Tag>
                                      )}{" "}
                                      {checkDoneStatus(patient?.created_at)}
                                    </span>
                                  </div>

                                  <div
                                    className="d-flex flex-wrap text-muted justify-content-between"
                                    style={{
                                      fontSize: getFontSize(
                                        "14px",
                                        "14px",
                                        "12px"
                                      ),
                                    }}
                                  >
                                    <span>
                                      {patient?.patient?.gender} |{" "}
                                      {patient?.patient?.age}
                                    </span>
                                    <span
                                      style={{
                                        wordBreak: "break-all",
                                        fontSize: getFontSize(
                                          "14px",
                                          "14px",
                                          "12px"
                                        ),
                                      }}
                                    >
                                      {patient?.patient?.mobile}
                                    </span>
                                    {patient?.due > 0 && (
                                      <span className="text-danger">
                                        ₹{patient?.due} Due
                                      </span>
                                    )}
                                  </div>
                                </div>

                                {/* Actions Dropdown */}
                                <div className="d-flex align-items-center ms-2">
                                  <Dropdown
                                    menu={{
                                      items:
                                        selectedIndex === "Consult"
                                          ? [
                                              {
                                                key: "1",
                                                label: "Hold",
                                                onClick: (e) => {
                                                  e.domEvent.stopPropagation();
                                                  updateAppointments(
                                                    patient,
                                                    "Hold"
                                                  );
                                                  setStatusUpdated(true);
                                                },
                                              },
                                              {
                                                key: "2",
                                                label: "Done",
                                                onClick: (e) => {
                                                  e.domEvent.stopPropagation();
                                                  updateAppointments(
                                                    patient,
                                                    "Done"
                                                  );
                                                  setStatusUpdated(true);
                                                },
                                              },
                                              {
                                                key: "3",
                                                label: "Delete",
                                                danger: true,
                                                onClick: (e) => {
                                                  e.domEvent.stopPropagation();
                                                  if (
                                                    window.confirm(
                                                      "Are you sure you want to delete this appointment?"
                                                    )
                                                  ) {
                                                    deleteAppoint(patient?.id); // <-- your delete function
                                                  }
                                                 
                                                },
                                              },
                                            ]
                                          : selectedIndex === "Hold"
                                          ? [
                                              {
                                                key: "1",
                                                label: "Done",
                                                onClick: (e) => {
                                                  e.domEvent.stopPropagation();
                                                  updateAppointments(
                                                    patient,
                                                    "Done"
                                                  );
                                                  setStatusUpdated(true);
                                                },
                                              },
                                            ]
                                          : [],
                                    }}
                                    trigger={["click"]}
                                    placement="bottomRight"
                                  >
                                    <Button
                                      className="btn btn-sm btn-light"
                                      onClick={(e) => e.stopPropagation()}
                                      style={{
                                        padding: getFontSize(
                                          "6px",
                                          "5px",
                                          "4px"
                                        ),
                                        fontSize: getFontSize(
                                          "16px",
                                          "14px",
                                          "12px"
                                        ),
                                      }}
                                    >
                                      <MoreOutlined />
                                    </Button>
                                  </Dropdown>
                                </div>
                              </div>
                            </div>
                          ))}
                        </div>
                      </Tab.Pane>
                    </Tab.Content>
                  </div>

                  {/* ====== Bottom Fixed Navigation Tabs ====== */}
                  {/* <Nav
                    variant="tabs"
                    className="border-top bg-white shadow-sm "
                    style={{
                      position: "sticky", // instead of fixed
                      bottom: 0,
                      left: 0,
                      width: "100%", // limited to parent div
                      display: "flex",
                      justifyContent: "space-around",
                      zIndex: 1000,
                    }}
                  >
                    {[
                      { key: "Consult", label: "Consult", color: "#a71a9fff" },
                      { key: "Hold", label: "Hold", color: "#f8351cff" },
                      { key: "Done", label: "Done", color: "#1c990bff" },
                    ].map(({ key, label, color }) => (
                      <Nav.Item key={key}>
                        <Nav.Link
                          eventKey={key}
                          onClick={() => setSelectedIndex(key)}
                          style={{
                            color,
                            fontWeight: "bold",
                            textAlign: "center",
                            fontSize: getFontSize("14px", "13px", "12px"),
                            borderTop:
                              selectedIndex === key
                                ? "3px solid #007bff"
                                : "2px solid transparent",
                            backgroundColor:
                              selectedIndex === key ? "#e0f8ff" : "transparent",
                            padding: "10px 0",
                            minWidth: "100px",
                          }}
                        >
                          {label} ({count?.[key] || 0})
                        </Nav.Link>
                      </Nav.Item>
                    ))}
                  </Nav> */}
                </Tab.Container>
              </div>
            </>
          )
        ) : (loading ? (
            <Loader />
          ) : (
          <>
            <Tab.Container
              activeKey="patients"
              onSelect={(k) => setSelectedIndex(k || "Consult")}
            >
              <Tab.Content
                className="flex-grow-1"
                style={{ minHeight: 0, paddingTop: "0px" }}
              >
                {/* Queue Tab */}
                <Tab.Pane eventKey="patients" className="h-100">
                  <div
                    className="upcoming-label p-2 bg-light border-bottom"
                    style={{ flexShrink: 0 }}
                  >
                    {/* <small
                  style={{ fontSize: getFontSize("13px", "12px", "11px") }}
                >
                  Upcoming
                </small> */}
                  </div>
                  <div
                    className="patient-list"
                    style={{
                      flex: 1,
                      overflowY: "auto",
                      overflowX: "hidden",
                      height: "calc(100% - 40px)",
                      scrollbarWidth: "thin",
                      scrollbarColor: "#ccc transparent",
                    }}
                  >
                    {filteredPatients?.map((patient, index) => (
                      <div
                        key={`${patient.id}-${patient.appointment_time}-${index}`}
                        className="patient-item p-2 border-bottom d-flex align-items-center cursor-pointer"
                        onClick={() => {
                          onPatientSelect({ patient }),
                            setAppoimentBooked(false);
                        }}
                        style={{
                          cursor: "pointer",
                          transition: "background-color 0.2s",
                          ":hover": {
                            backgroundColor: "#f8f9fa",
                          },
                        }}
                        // onMouseEnter={(e) => (e.target.style.backgroundColor = "#f8f9fa")}
                        // onMouseLeave={(e) => (e.target.style.backgroundColor = "transparent")}
                      >
                        <div
                          style={{
                            width: "40px",
                            height: "40px",
                            borderRadius: "20%",
                            padding: "2px",
                            overflow: "hidden",
                            flexShrink: 0,
                            marginRight: "10px",
                            backgroundColor: "#c5c5c5ff",
                          }}
                        >
                          <img
                            src={patient?.gender === "Male" ? male : female}
                            alt="Patient"
                            style={{
                              width: "100%",
                              height: "100%",
                              objectFit: "cover",
                            }}
                          />
                        </div>
                        <div
                          className="patient-info flex-grow-1"
                          style={{ minWidth: 0 }}
                        >
                          <div className="d-flex justify-content-between align-items-center mb-1">
                            <h6
                              className="mb-0 text-truncate"
                              style={{
                                fontSize: getFontSize("16px", "16px", "14px"),
                                fontWeight: 600,
                                maxWidth: "70%",
                              }}
                            >
                              {patient?.first_name}{patient?.middle_name && ` ${patient?.middle_name}`} {patient?.last_name}
                            </h6>
                            <span
                              className="text-muted"
                              style={{
                                fontWeight: 600,
                                fontSize: getFontSize("13px", "13px", "11px"),
                                flexShrink: 0,
                              }}
                            >
                              {patient?.mobile}
                            </span>
                          </div>

                          {/* Row 2: Gender | Age | Mobile | Due */}
                          <div
                            className="d-flex flex-wrap text-muted justify-content-between"
                            style={{
                              fontSize: getFontSize("14px", "14px", "12px"),
                            }}
                          >
                            <span>
                              {patient?.gender} | {patient?.age}
                            </span>
                            {/* <span style={{ wordBreak: "break-all" }}>
                                    {patient?.mobile}
                                  </span> */}
                            {patient?.due > 0 && (
                              <span className="text-danger">
                                ₹{patient?.due} Due
                              </span>
                            )}
                          </div>
                        </div>

                        <div
                          className="d-flex align-items-center"
                          style={{ flexShrink: 0 }}
                        >
                          {/* {patient.isUpNext && (
                        <div className="up-next-tag me-2">
                          <span
                            className="badge bg-primary"
                            style={{
                              fontSize: getFontSize("10px", "9px", "8px"),
                              padding: "4px 8px",
                            }}
                          >
                            Up Next
                          </span>
                        </div>
                      )} */}
                          {/* <Dropdown
                        menu={{
                          items: [
                            {
                              key: "1",
                              label: "Arrival",
                              onClick: (e) => {
                                e.domEvent.stopPropagation();
                                updateAppointments(patient, "Arrival");
                                setStatusUpdated(true);
                              },
                            },
                            {
                              key: "2",
                              label: "Start Consult",
                              onClick: (e) => {
                                e.domEvent.stopPropagation();
                                updateAppointments(patient, "Consult");
                                setStatusUpdated(true);
                              },
                            },
                          ],
                        }}
                        trigger={["click"]}
                        placement="bottomRight"
                      >
                        <Button
                          className="btn btn-sm btn-light"       
                          onClick={(e) => e.stopPropagation()}
                          style={{
                            padding: getFontSize("6px", "5px", "4px"),
                            fontSize: getFontSize("16px", "14px", "12px"),
                          }}
                        >
                          <MoreOutlined />
                        </Button>
                      </Dropdown> */}
                        </div>
                      </div>
                    ))}
                  </div>
                </Tab.Pane>

                {/* Seen Tab */}
                <Tab.Pane eventKey="seen" className="h-100"></Tab.Pane>

                {/* Cancelled Tab */}
                <Tab.Pane eventKey="cancelled" className="h-100">
                  <div className="text-center py-5 text-muted">
                    <p
                      style={{ fontSize: getFontSize("14px", "13px", "12px") }}
                    >
                      No cancelled appointments
                    </p>
                  </div>
                </Tab.Pane>
              </Tab.Content>
            </Tab.Container>
          </>)
        )}
      </div>
    </div>
  );
}

Lab_PatientsQueue.propTypes = {
  onPatientSelect: PropTypes.func.isRequired,
  appoimentBooked: PropTypes.bool.isRequired,
  setAppoimentBooked: PropTypes.func.isRequired,
};
